import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { ALL_BUY_IN_AMOUNTS } from '../../../constants/buyInConstants';
import { useAppSelector } from '../../../redux/store';
import { ALL_CREATE_ROOM_TYPE_PROPERTIES, ALL_CURRENCIES } from '../../../types/sharedTypes';
import { getBuyInRangeAmounts } from '../../../utils/buyInRangeUtils';
import { getCurrencyAmountString } from '../../../utils/currencyUtils';
export const BuyInRangeDisplay = () => {
    const buyIn = useAppSelector((state) => ALL_BUY_IN_AMOUNTS[state.createGame.buyInIndex]);
    const currency = useAppSelector((state) => ALL_CURRENCIES[state.createGame.currencyIndex]);
    const buyInRangeAmounts = useAppSelector((state) => getBuyInRangeAmounts(buyIn, state.createGame.buyInRange));
    const roomType = useAppSelector((state) => state.createGame.roomType);
    if (!ALL_CREATE_ROOM_TYPE_PROPERTIES[roomType].hasBuyinRangeControl) {
        return null;
    }
    const [minBuyIn, maxBuyIn] = buyInRangeAmounts;
    if (minBuyIn === maxBuyIn) {
        return null;
    }
    return (_jsxs(Typography, { component: 'div', variant: 'subtitle2', children: ["Buy-in Range: ", getCurrencyAmountString(minBuyIn, currency), " \u2014 ", getCurrencyAmountString(maxBuyIn, currency)] }));
};
